<template>
      <HeaderTrade />

      <!-- Container Start { -->
      <div id="container">
        <!-- Contents Start { -->
        <div id="contents">

         <!-- 모의투자 임시 링크 start -->
         <!-- <div class="py-3">
            <p class="px-2">모의투자 html 임시 링크</p>
            <router-link :to="{ name: 'ItemListCoin'}" class="btn btn-sm btn-primary mx-2 my-1">종목</router-link>
            <router-link :to="{ name: 'mChart'}" class="btn btn-sm btn-primary mx-2 my-1">차트</router-link>
            <router-link :to="{ name: 'OrderBook'}" class="btn btn-sm btn-primary mx-2 my-1">호가창</router-link>
            <router-link :to="{ name: 'MtradeArea'}" class="btn btn-sm btn-primary mx-2 my-1">거래화면</router-link>
            <router-link :to="{ name: 'mResult'}" class="btn btn-sm btn-primary mx-2 my-1">결과화면</router-link>
            <router-link :to="{ name: 'mRanking'}" class="btn btn-sm btn-primary mx-2 my-1">랭킹</router-link>
         </div> -->
         <!-- //모의투자 임시 링크 end -->

         <div class="contents-area">
           <TradeMainTop />
          <!-- 모의투자 : 메인 > 실시간 랭크 -->
          <div class="sts-main-rank">
            <div class="main-rank-box">
              <!-- <h3>모의투자 참가자 <strong class="text-danger">1,024 명</strong></h3> -->
              <!-- class 설명 
                  .table tr  >> 보합
                  .table tr.up  >> 상승
                  .table tr.down  >> 하락
              -->
              <!-- item : 주식거래 start -->
              <RankBoard 
                 :title="'주식거래 손익 TOP 10'"
                 :tradeType="'S'"
              />
              <!-- //item : 주식거래 end -->

              <!-- item : 선물거래 start -->
              <RankBoard 
                 :title="'선물거래 손익 TOP 10'"
                 :tradeType="'F'"
              />
              <!-- //item : 선물거래 end -->

              <!-- item : 코인거래 start -->
              <RankBoard 
                 :title="'코인거래 손익 TOP 10'"
                 :tradeType="'C'"
              />
              <!-- //item : 코인거래 end -->

              <!-- item : 코인선물 start -->
              <RankBoard 
                 :title="'코인선물 손익 TOP 10'"
                 :tradeType="'G'"
              />
              <!-- //item : 코인선물 end -->

            </div>
          </div>

          <!-- 모의투자 광고 start -->
          <!-- <div class="sts-ad-box">
            <div><img src="@/assets/images/trade/sts_ad_sam.png" alt="ad"></div>
          </div> -->
          <!-- //모의투자 광고 end -->

         </div>

        </div>
        <!-- } Contents End -->

         <div class="main-try-btn" v-if="isTryBtnBanner">
            <div class="try-box" @click="onScrollTop">
               <span class="img"><img src="@/assets/images/main/popup_try.png" alt="모의투자 신청하기"></span>
               <span class="txt">모의투자대회 참가신청 하기</span>
            </div>
            <div class="close-box" @click="onBannerClose">
               <span>&times;</span>
            </div>
         </div>

      </div>
      <!-- } Container End -->

      <Footer/>

   <MainNoticeModal
      v-if="showModal" 
      @close="closeModal"
      @cancle="closeModal"
      @ok="okModal"
   />
</template>

<script>
import HeaderTrade from '@/components/HeaderTrade.vue';
import TradeMainTop from '@/components/trade/TradeMainTop.vue';
import Footer from '@/components/Footer.vue';
import { useStore } from 'vuex';
import { ref, onMounted, onUnmounted } from 'vue';
import RankBoard from '@/components/RankBoard_home.vue'
import VueCookies from "vue-cookies";
import MainNoticeModal from '@/components/popups/MainNoticeModal.vue';
import { useApicall } from '@/composables/commonFn';


export default {
    components:{   
    HeaderTrade,
    Footer,
    TradeMainTop,
    RankBoard,
    MainNoticeModal
 },
 setup(){
    const store = useStore();
   // trace( 'VtradeMain')
    store.commit('common/CHANGE_CURRENT_PAGE', 'Home');  
    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_0'); 

    const { apiCall_g } = useApicall();
    const showModal = ref(false);
    const popupListCount = ref('');

   const scrWaiting = ref(false);
   const isTryBtnBanner = ref(false);

   onMounted( async()=> {
      popupListCount.value = await getPopupCount();
      if(popupListCount.value > 0 ) {
         noticePopupOpen();
      }
    //  getMenuRewardOnOff();
      document.addEventListener('scroll', scrollHandler);
   })

   onUnmounted(() => {
      document.removeEventListener('scroll', scrollHandler);
   })

    const okModal = async() => {
      showModal.value = false;
      document.getElementById('wrap').classList.remove('scr-none');
    }    

   const closeModal = () => {
      showModal.value = false; 
   }

   const noticePopupOpen = () => {
      var popupCookie = VueCookies.get('popCookie');
      if(popupCookie) {
         showModal.value = false;
      } else {
         showModal.value = true;
         document.getElementById('wrap').classList.add('scr-none');
      }
   }

    const getPopupCount = async() => {
      const res = await apiCall_g(`board/list?&categoryType=aboard&categoryCode=popup`);
      var result = res.dataCount;
      if(!result) result = [];
      return result
    }
    
    const scrollHandler = () => {
      if(!scrWaiting.value) {
         scrWaiting.value = true;
         const currentScroll = window.scrollY;
         if(currentScroll > 60) {
            isTryBtnBanner.value = true;
         } else {
            isTryBtnBanner.value = false;
         }
         // console.log('scrollHandler', scrWaiting.value, currentScroll,)
         // Event Throttle 100 ms
         setTimeout(()=> {
            scrWaiting.value = false;
            }, 100); 
      }
   }

    const onScrollTop = () => {
      document.body.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    const onBannerClose = () => {
      isTryBtnBanner.value = false;
      document.removeEventListener('scroll',scrollHandler);
    }




    return{
         showModal,
         okModal,
         closeModal,
         popupListCount,
         noticePopupOpen,
         scrollHandler,
         isTryBtnBanner,
         onScrollTop,
         onBannerClose,
    }
 }


}
</script>

<style>

</style>